/**
 * Airtable Rate Limiting Module
 * 
 * Handles rate limiting for Airtable API requests
 * Implements delays between requests to avoid hitting API limits
 */

// Rate limiting constants
const RATE_LIMIT_DELAY = 100; // ms between requests
let lastRequestTime = 0;

// Rate limiting constants for Metadata API
const METADATA_RATE_LIMIT_DELAY = 200; // ms between requests
let lastMetadataRequestTime = 0;

/**
 * Implement rate limiting for REST API
 */
export async function respectRateLimit(): Promise<void> {
  const now = Date.now();
  const timeSinceLastRequest = now - lastRequestTime;
  
  if (timeSinceLastRequest < RATE_LIMIT_DELAY) {
    const delay = RATE_LIMIT_DELAY - timeSinceLastRequest;
    await new Promise(resolve => setTimeout(resolve, delay));
  }
  
  lastRequestTime = Date.now();
}

/**
 * Implement rate limiting for Metadata API
 */
export async function respectMetadataRateLimit(): Promise<void> {
  const now = Date.now();
  const timeSinceLastRequest = now - lastMetadataRequestTime;
  
  if (timeSinceLastRequest < METADATA_RATE_LIMIT_DELAY) {
    const delay = METADATA_RATE_LIMIT_DELAY - timeSinceLastRequest;
    await new Promise(resolve => setTimeout(resolve, delay));
  }
  
  lastMetadataRequestTime = Date.now();
} 
